import { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import TagsModal from '../Front-Components/TagsModal';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../../Utilities/Breadscrumb/Breadcrumbs';
import PagesSearchComponent from '../Front-Components/PagesSearchComponent';


function Header() {
  const [TagModel, SetTagModel] = useState(false);
  const handleClose = () => SetTagModel(false);
  const handleTagClick = () => SetTagModel(true);

  const [position, setPosition] = useState(window.scrollY);
  const [visible, setVisible] = useState(true)
  const headerRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      let moving = window.scrollY

      setVisible(position > moving);
    
      setPosition(moving)
      // console.log(position > moving);
    };
    window.addEventListener("scroll", handleScroll);
    return (() => {
      window.removeEventListener("scroll", handleScroll);
    })
  })


  const cls = visible ? "visible" : "hidden";

  function navigateToHome() {
    navigate('/');
  }

  return (
    <>
        <Navbar
          ref={headerRef}
          expand="lg"
          className={`bg-body-tertiary sticky-top transition-navbar header-height w-100`}
        >
    
            <Navbar.Brand className='btn' onClick={() => navigateToHome()}>Stack</Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll w-100">
              <Nav className="me-auto " navbarScroll>
                <Nav.Link onClick={handleTagClick}>Tags</Nav.Link>
                <span className='mx-3 h4 text-success'> | </span>
                <div className="d-flex align-items-center">
                  <Breadcrumbs />
                </div>
              </Nav>

              <PagesSearchComponent/>
            </Navbar.Collapse>
        </Navbar>
      

      {TagModel && <TagsModal show={TagModel} handleClose={handleClose} />}
    </>

  );
}

export default Header;
